<template>
	<div class="cashdesks-control">
		<div class="header">
			<h3
				@click="toggleCollapsibleComponent('openedCashdesks')"
				@keydown.enter="toggleCollapsibleComponent('openedCashdesks')"
				class="collapse-header gray-50"
			>
				Відкриті другорядні каси
				<div v-if="openedCashdesks && openedCashdesks.length" class="count">
					{{ openedCashdesks ? openedCashdesks.length : 0 }}
				</div>
				<i :class="collapsedComponents.includes('openedCashdesks') ? 'desc' : 'asc'" />
			</h3>
			<div class="search-input-wrap">
				<NP-Input
					v-if="openedCashdesks && openedCashdesks.length"
					v-model="tableSearchQuery"
					class="table-search-input"
					placeholder="Пошук касира"
					variant="search"
				/>
				<div
					v-if="openedCashdesks && openedCashdesks.length && tableSearchQuery"
					class="clear-table-search-input"
					@click="() => (tableSearchQuery = '')"
				>
					<div class="icon" />
				</div>
			</div>
		</div>
		<CashdesksTable
			v-if="!collapsedComponents.includes('openedCashdesks') && openedCashdesks && openedCashdesks.length"
			:root="root"
			:user="user"
			:cashdesks="openedCashdesks"
			:toggle-closal-shift-modal="toggleClosalShiftModal"
			:toggle-cashdesk-action-modal="toggleCashdeskActionModal"
			:toggle-pending-orders-modal="togglePendingOrdersModal"
			:pending-orders="pendingCashbookOrders"
			:search-query="tableSearchQuery"
		/>
		<CashdeskActionModal
			v-if="state.render === 'cashdesk_action_modal'"
			:user="user"
			:order="cashdeskActionModalData.order"
			:cashdesk="cashdeskActionModalData.cashdesk"
			:action="cashdeskActionModalData.action"
			:toggle="toggleCashdeskActionModal"
			:validation-errors="validationErrors"
			:loading-actions="loadingActions"
			:lists="lists"
			:create-cash-to-cashdesk="createCashToCashdesk"
			:confirm-cash-to-cashdesk="confirmCashToCashdesk"
			:confirm-cash-from-cashdesk="confirmCashFromCashdesk"
			:cancel-created-order="cancelCreatedOrder"
			:force-close-cashdesk-shift="forceCloseCashdeskShift"
		/>
		<CashdeskCourierOrderModal
			v-if="state.render === 'cashdesk_courier_order_modal'"
			:toggle="toggleCashdeskCourierModal"
			:create="createCashFromCourier"
			:lists="root.lists"
			:pending-orders="pendingCashbookOrders"
			:update-pending-orders="updatePendingOrders"
			:loading-actions="loadingActions"
			:cashdesk="cashdeskData"
		/>
		<CashdeskPendingOrdersModal
			v-if="state.render === 'cashdesk_pending_orders_modal'"
			:cashdesk="cashdeskData"
			:pending-orders="pendingCashbookOrders"
			:create-order="toggleCashdeskCourierModal"
			:toggle="togglePendingOrdersModal"
			:confirm="confirmShiftClosal"
			:loading-actions="loadingActions"
		/>
		<CashdeskClosalModal
			v-if="state.render === 'closal_shift_modal'"
			:cashdesk="cashdeskData"
			:pending-orders="pendingCashbookOrders"
			:create-order="toggleCashdeskCourierModal"
			:toggle="toggleClosalShiftModal"
			:confirm="confirmShiftClosal"
			:loading-actions="loadingActions"
		/>
	</div>
</template>

<script>
import CashdesksTable from './cashdesks-table';
import CashdeskActionModal from './cashdesk-action-modal';
import CashdeskClosalModal from './cashdesk-closal-modal';
import CashdeskCourierOrderModal from './cashdesk-courier-order-modal';
import CashdeskPendingOrdersModal from './cashdesk-pending-orders-modal';

export default {
	name: 'OpenedCashdesks',
	components: {
		CashdesksTable,
		CashdeskActionModal,
		CashdeskClosalModal,
		CashdeskCourierOrderModal,
		CashdeskPendingOrdersModal
	},
	props: {
		root: { type: Object, default: null },
		salepoint: { type: Object, default: null },
		state: { type: Object, default: null },
		user: { type: Object, default: null },
		lists: { type: Object, default: null },
		cashdeskActionModalData: { type: Object, default: () => ({}) },
		openedCashdesks: { type: Array, default: () => [] },
		validationErrors: { type: Array, default: () => [] },
		collapsedComponents: { type: Array, default: () => [] },
		loadingActions: { type: Array, default: () => [] },
		pendingCashbookOrders: { type: Array, default: () => [] },
		toggleCollapsibleComponent: { type: Function, default: null },
		toggleCashdeskActionModal: { type: Function, default: null },
		createCashToCashdesk: { type: Function, default: null },
		confirmCashToCashdesk: { type: Function, default: null },
		confirmCashFromCashdesk: { type: Function, default: null },
		cancelCreatedOrder: { type: Function, default: null },
		toggleClosalShiftModal: { type: Function, default: null },
		confirmShiftClosal: { type: Function, default: null },
		forceCloseCashdeskShift: { type: Function, default: null },
		cashdeskData: { type: Object, default: null },
		toggleCashdeskCourierModal: { type: Function, default: null },
		togglePendingOrdersModal: { type: Function, default: null },
		updatePendingOrders: { type: Function, default: null },
		createCashFromCourier: { type: Function, default: null }
	},
	data() {
		return {
			tableSearchQuery: ''
		};
	}
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/variables.scss';
@import '@assets/scss/mixins.scss';
$icon-close: '~@assets/images/icon-close.svg';
$icon-search: '~@assets/images/icon-search.svg';

.cashdesks-control {
	width: 100%;
	padding: 20px 24px;
	margin-top: 20px;
	box-sizing: border-box;
	background-color: $white;
	border-radius: $border-radius;
	.header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		.search-input-wrap {
			position: relative;
			::v-deep .table-search-input {
				&.input.search {
					input {
						width: 450px;
						height: 26px;
						padding-top: 8px;
						background: $white;
						border: none;
						border-radius: 0;
						font-size: 14px;
						border-bottom: 1px solid $gray-30;
					}
					.search-icon {
						position: absolute;
						top: 1px;
						left: 10px;
						@include make-icon($icon-search, #a7b0be, 18px, 18px);
					}
					&.focused {
						input {
							border-left: 1px solid $white;
							border-bottom: 2px solid $gray-50;
						}
					}
				}
			}
			.clear-table-search-input {
				position: absolute;
				right: 0;
				top: 0px;
				display: flex;
				justify-content: center;
				align-items: center;
				width: 22px;
				height: 22px;
				border-radius: 50%;
				background: $gray-10;
				&:hover {
					cursor: pointer;
					background: $gray-20;
				}
				.icon {
					@include make-icon($icon-close, $gray-50, 15px, 15px);
				}
			}
		}
		.collapse-header {
			@include collapse-header();
		}
		@include mobile() {
			display: flex;
			flex-direction: column;
			padding: 16px;
		}
		@include small-desktop() {
			.search-input-wrap {
				::v-deep .table-search-input {
					&.input.search {
						input {
							width: 426px;
						}
					}
				}
			}
		}
	}
}
</style>
